export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8463.d9cdac95.jpg";